import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState, useRef } from "react";
import { Button, Container, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import "./editanswer.css";

import { useCookies } from "../../../../hooks/useCookies";
import Sidebar from "../../../userflow/components/sidebar/sidebar";
import answer from "../../../../assets/images/answer.png";
import { useAlert } from "../../../../Context/AlertModalContext";
import { questionsDefaultAnswers } from "../../../../utils/constants";
import QuestionPrompt from "./QuestionPrompt/index.jsx";
import AlertModal from "./AlertModal/index.jsx";
import * as profileActions from "../../../../actions/Profile.jsx";
import { useProfile } from "../../../../components/userflow/components/context/ProfileContext.jsx";
import { useQuestion } from "../../../../Context/QuentionContext.jsx";

export default function UpdateAnswers() {
  // State variables
  const [showAnswerModal, setShowAnswerModal] = useState(false);
  const [count, setCount] = useState(0);
  const [updateCount, setUpdateCount] = useState(0);
  const [answerModalData, setAnswerModalData] = useState({});
  const [questions, setQuestions] = useState([]);
  const [alert, setAlert] = useState(false);
  const [localAnswers, setLocalAnswers] = useState({});
  const [deletedAnswers, setDeletedAnswers] = useState(new Set());
  const [refresh, setRefresh] = useState(false);

  // Hooks and context
  const { getCookie } = useCookies();
  const navigate = useNavigate();
  const alertmodal = useAlert();
  const hasFetchedRef = useRef(false);
  const { updateProfile } = useProfile();
  const { updateQuestion, fetchUpdatedData } = useQuestion();

  // Computed values
  const approvalstatus = getCookie("approval");
  const token = getCookie("token");
  const totalCount = count + updateCount;

  // API functions
  const fetchQuestionsList = async () => {
    try {
      const response = await profileActions.questionAnswersList();
      if (!response) throw new Error("Failed to fetch questions");
      const data = await response;
      setQuestions(data.questions);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCounts = async () => {
    try {
      const response = await profileActions.getQuestionsCount();
      if (!response) throw new Error("Failed to fetch counts");
      const data = await response;
      setCount(data.count);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchUpdateCount = async () => {
    try {
      const response = await profileActions.getUpdateQuestionsCount();
      if (!response) throw new Error("Failed to fetch update count");
      const data = await response;
      setUpdateCount(data.count);
    } catch (error) {
      console.error("Error fetching update count:", error);
    }
  };

  // Event handlers
  const handleDeleteAnswer = (questionId) => {
    setLocalAnswers((prev) => ({ ...prev, [questionId]: "" }));
    setDeletedAnswers((prev) => new Set(prev).add(questionId));

    setQuestions((prevQuestions) =>
      prevQuestions?.map((q) =>
        q.question_id === questionId ? { ...q, answer: "" } : q
      )
    );
  };

  const handleAnswerSave = (questionId, newAnswer) => {
    setShowAnswerModal(false);
    setQuestions((prevQuestions) =>
      prevQuestions.map((q) =>
        q.question_id === questionId ? { ...q, answer: newAnswer } : q
      )
    );
    setLocalAnswers((prev) => {
      return { ...prev, [questionId]: newAnswer };
    });
  };

  const handleSaveUpdates = async () => {
    try {
      const updates = [];
      let finalAnswersCount = 0;

      questions.forEach(q => {
        const questionId = q.question_id;
        const originalAnswer = q.answer || "";
        const hasLocalAnswer = localAnswers.hasOwnProperty(questionId);
        const newAnswer = localAnswers[questionId];

        if (approvalstatus === "APPROVED") {
          if (hasLocalAnswer) {
            if (newAnswer) {
              updates.push({ question_id: questionId, answer: newAnswer });
              finalAnswersCount++;
            } else if (originalAnswer || deletedAnswers.has(questionId)) {
              updates.push({ question_id: questionId }); // mark for deletion
            }
          } else if (originalAnswer) {
            finalAnswersCount++;
          }
        } else {
          if (originalAnswer) {
            updates.push({ question_id: questionId, answer: originalAnswer });
            finalAnswersCount++;
          }
          if (hasLocalAnswer && newAnswer) {
            const alreadyIncluded = updates.find(u => u.question_id === questionId);
            if (!alreadyIncluded) {
              updates.push({ question_id: questionId, answer: newAnswer });
              finalAnswersCount++;
            }
          }
        }
      });

      Object.entries(localAnswers).forEach(([questionId, newAnswer]) => {
        const id = Number(questionId);
        const isNewQuestion = !questions.find(q => q.question_id === id);
        if (isNewQuestion && newAnswer) {
          updates.push({ question_id: id, answer: newAnswer });
          finalAnswersCount++;
        }
      });

      // 3. Validate exactly 2 answers
      if (finalAnswersCount !== 2) {
        alertmodal.setModal({
          show: true,
          message: `Only 2 prompts can be answered. Currently you have ${finalAnswersCount}.`,
        });
        return;
      }

      if (updates.length > 0) {
        const payload = { update: updates };
        const response = approvalstatus === "APPROVED"
          ? await profileActions.updateQuestionAnswerRequest(payload)
          : await profileActions.updateQuestionAnswer(payload);

        if (response) {
          setLocalAnswers({});
          setDeletedAnswers(new Set());
          setRefresh(true);
          await fetchQuestionsList();
          await updateProfile("update");
          await fetchUpdatedData();
          if (approvalstatus !== "APPROVED") {

            navigate("/updateprofile");
          }
        }
      } else {
        navigate("/updateprofile");
      }
    } catch (error) {
      console.error("Error saving answers:", error);
    }
  };

  const refreshpage = () => {
    setRefresh(!refresh);
  };

  // Effects
  useEffect(() => {
    if (!token) return;
    fetchCounts();
    fetchQuestionsList();
    fetchUpdateCount();
  }, [token, refresh]);

  useEffect(() => {
    if (hasFetchedRef.current) return;

    if (updateQuestion !== undefined) {
      if (updateQuestion?.length > 0) {
        hasFetchedRef.current = true;

        alertmodal.setModal({
          show: true,
          message:
            " Please note that changes to your written prompts will be reviewed by our admin team before going live. This process may take up to 48 hours.",
          title: "",
          onButtonClick: () => {
            navigate("/updateprofile");
          },
        });
      }
    }
  }, [updateQuestion, approvalstatus, alertmodal, navigate]);

  return (
    <Sidebar>
      <div className="update-answers-profile-ques">
        <div className="update-answers-container">
          <QuestionPrompt
            show={showAnswerModal}
            modalData={answerModalData}
            onSave={handleAnswerSave}
            onHide={() => setShowAnswerModal(false)}
          />
          <AlertModal
            show={alert}
            updatecount={updateCount}
            alertmodal={alertmodal}
            count={count}
            onHide={() => setAlert(false)}
          />

          <Container className="update-answers-main">
            <Container className="update-answers-content">
              <Container className="update-answers-details">
                <Container className="update-answers-section">
                  <Container className="update-answers-text">
                    <Image width="40px" height="40px" src={answer} />
                    <p>Update: Write your profile answers</p>
                  </Container>
                  <p className="update-required-prompts-text">
                    2 prompts are required, but you can add more.
                  </p>
                  <div className="update-questions-type">
                    <div className="update-questions-container">
                      {questions?.map((question, index) => (
                        <div
                          tabIndex={0}
                          key={index}
                          className={`update-question-item ${question.answer ? 'answered' : ''} ${!question.answer && questions.filter(q => q.answer && q.answer.trim() !== '').length >= 2 ? 'disabled' : ''
                            }`}
                          onClick={() => {
                            // Count answered questions
                            const answeredCount = questions.filter(q => q.answer && q.answer.trim() !== '').length;

                            // Allow opening modal if:
                            // 1. This question already has an answer (editing existing answer)
                            // 2. Less than 2 questions are answered (can add new answer)
                            if (question.answer || answeredCount < 2) {
                              setAnswerModalData({
                                heading: question.question,
                                placeholder: questionsDefaultAnswers[index],
                                answer: question?.answer,
                                questionId: question.question_id,
                                onAnswerSaved: handleAnswerSave,
                                refreshpage: refreshpage,
                              });
                              setShowAnswerModal(true);
                            } else {
                              // Show alert if trying to add more than 2 answers
                              setAlert(true);
                            }
                          }}
                        >
                          <div>
                            <div className="update-job-text-question">
                              {question.question}
                            </div>
                            <div className="update-job-text-question-answer update-question-answer-text">
                              {question.answer
                                ? question.answer.split(' ').slice(0, 10).join(' ') + (question.answer.split(' ').length > 10 ? '...' : '')
                                : questionsDefaultAnswers[index]?.substring(0, 10) + "..."
                              }
                            </div>
                            <div className="update-job-text-question-answer">
                              {question.description}
                            </div>
                          </div>

                          <div className="update-question-actions">
                            {question?.answer && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.nativeEvent.stopImmediatePropagation();
                                  handleDeleteAnswer(question.question_id);
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M15 1L1 15M1.00001 1L15 15"
                                    stroke="#424242"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            )}

                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className={`update-edit-icon ${updateQuestion?.length > 0 ? 'disabled' : ''}`}
                            >
                              <path
                                d="M12.8346 5.5L7.33464 11V14.6667H11.0013L16.5013 9.16667M12.8346 5.5L15.5846 2.75L19.2513 6.41667L16.5013 9.16667M12.8346 5.5L16.5013 9.16667M9.16797 3.66667L3.66797 3.66667L3.66797 18.3333L18.3346 18.3333V12.8333"
                                stroke="url(#paint0_linear_778_6844)"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_778_6844"
                                  x1="12.0869"
                                  y1="2.10069"
                                  x2="12.0869"
                                  y2="19.9566"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#FC8C66" />
                                  <stop offset="1" stopColor="#F76A7B" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Container>
              </Container>
              <div className="update-button-container">
                <Button
                  type="button"
                  className="update-answers-nxt-btn"
                  onClick={() => {
                    if (
                      count === 2 ||
                      updateCount === 2 ||
                      totalCount === 2
                    ) {
                      navigate("/updateprofile");
                    } else {
                      setAlert(true);
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  className="update-answers-nxt-btn2"
                  onClick={handleSaveUpdates}
                >
                  Save
                </Button>
              </div>
            </Container>
          </Container>
        </div>
      </div>
    </Sidebar>
  );
}